/**
 * Display the lot data returned by the P10 Put Down Mill query that is
 * stored in the dynamicInputResult field of the request. A no-lots response
 * ([{ lotNumber: null, ... }]) renders nothing.
 * @param {Local.PutDownMillLookupProps} props
 */
export const PutDownMillLookup = ({ result }) => {
  const lots = (result || []).filter((lot) => lot?.lotNumber);
  if (!lots.length) return null;
  const display = lots.map((lot) => `${lot.lotNumber} (${lot.qOH}) ${lot.lotDate}`).join(' <> ');
  return <span data-testid='dynamic-input-result'>{`Description: ${display}`}</span>;
};
